import { createClientSharedComposable, getStore } from '@global-store/store'
import type { WishlistStore } from '@shared/global-store/stores/wishlist/types'
import {
  addWishlistItem,
  deleteWishlistItem,
  getWishlistById,
} from '@shared/shop-api/wishlist/api'
import type { Wishlist } from '@shared/shop-api/wishlist/types'
import { defineStore } from 'pinia'

import { trackError } from '@fond-of/telemetry'

export const useWishlistStore = createClientSharedComposable(() =>
  defineStore('wishlist', {
    state: (): WishlistStore => ({
      wishlist: null,
    }),

    getters: {
      itemCount: (state) => state.wishlist?.wishlistItems?.length ?? 0,
      wishlistId: (state) => state.wishlist?.id ?? '',
      wishlistItemIds: (state) =>
        state.wishlist?.wishlistItems?.map((item) => item.id) ?? [],
      isInitialized: (state) => !!state.wishlist?.createdAt,
    },
    actions: {
      setWishlist(wishlist: Wishlist) {
        this.wishlist = wishlist
      },

      async setWishlistItem(item: string) {
        try {
          await addWishlistItem(this.wishlistId, item)
          const newWishlist = await getWishlistById(this.wishlistId)

          if (!newWishlist) {
            console.log('No wishlist found')
            return
          }

          this.setWishlist(newWishlist)
        } catch (error) {
          trackError(error)
        }
      },

      async removeItem(sku: string) {
        if (!this.wishlist) return
        try {
          await deleteWishlistItem(this.wishlist.id, sku)
          const newWishlist = await getWishlistById(this.wishlistId)

          if (!newWishlist) {
            console.log('No wishlist found')
            return
          }

          this.setWishlist(newWishlist)
        } catch (error) {
          trackError(error)
        }
      },
    },
  })(getStore())
)
